export default "__VITE_ASSET__BMnS3_oA__"